export const EmptyGuid = '00000000-0000-0000-0000-000000000000'
export const JID_RB = 'RB'
export const JID_SE = 'SE'
export const SEActivityText = 'Special Operations'
export const ENV_JID_START = process.env.REACT_APP_JID_START ?? ''
export const ENV_JID_STOP = process.env.REACT_APP_JID_STOP ?? ''
export const ENV_JID_BREAK = process.env.REACT_APP_JID_BREAK ?? ''
export const ENV_JID_ILLNESS = process.env.REACT_APP_JID_ILLNESS ?? ''
export const ENV_JID_EDUCATION = process.env.REACT_APP_JID_EDUCATION ?? ''
export const ENV_JID_ADDITIONALENTRY = process.env.REACT_APP_JID_ADDITIONALENTRY ?? ''
export const ENV_JID_INTERNAL = process.env.REACT_APP_JID_INTERNAL ?? ''
export const ENV_JID_WORKSCOUNC = process.env.REACT_APP_JID_WORKSCOUNC ?? ''
export const ENV_JID_RBSECOMP = process.env.REACT_APP_JID_RBSECOMP ?? ''